<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <button
      *ngIf="showHeaderCloseButton"
      type="button"
      class="btn-close"
      (click)="activeModal.dismiss()"
    ></button>
  </div>
  <div class="modal-body">
    <p>{{ message }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn" (click)="reject()">
      {{ rejectButtonText }}
    </button>
  
    <button type="button" class="btn btn-primary" (click)="confirm()">
      {{ confirmButtonText }}
    </button>
  </div>
  